import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Logout-3--Streamline-Flex"
    >
        <desc>{'Logout 3 Streamline Icon: https://streamlinehq.com'}</desc>
        <g id="logout-3--arrow-enter-right-logout-point-square">
            <path
                id="Subtract"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12.6651 2.55754c-0.481 -0.85919 -1.359 -1.47238 -2.3778 -1.585931C9.2178 0.852392 8.11964 0.75 7 0.75c-1.11963 0 -2.21779 0.102392 -3.28734 0.221609C2.2727 1.13211 1.114 2.29082 0.959867 3.73147 0.846083 4.79498 0.75 5.88684 0.75 7c0 1.11315 0.096084 2.20502 0.209867 3.2685C1.114 11.7092 2.2727 12.8679 3.71266 13.0284 4.78221 13.1476 5.88037 13.25 7 13.25s2.2178 -0.1024 3.2873 -0.2216c1.0188 -0.1136 1.8968 -0.7268 2.3778 -1.5859"
                strokeWidth={1}
            />
            <path
                id="Vector 7"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.53564 7 13.25 7"
                strokeWidth={1}
            />
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5547 4.15625c1.0781 0.56875 2.1562 1.70625 2.6953 2.84371 -0.5391 1.13754 -1.6172 2.27504 -2.6953 2.84379"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
